// extracted by mini-css-extract-plugin
export default {"alert":"Alert_alert__2+iJp","error":"Alert_error__nXAxo","success":"Alert_success__D+deF","warning":"Alert_warning__Q7Ugk","info":"Alert_info__r41Wi"};